import React from 'react';

const NotShared = (props) => {
	return (
		<svg
			version="1.1"
			baseProfile="tiny"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			width={props.width}
			height={props.height}
			xmlSpace="preserve"
			className="pics align-middle mr-1"
			viewBox="0 0 100 100"
		>
			<g>
				<path fill="#606060" d="M47.859,39.005c1.559-1.559,3.637-2.417,5.852-2.417c2.261,0,4.364,0.86,5.917,2.417l1.574,1.574
					c3.665-4.466,5.535-9.699,5.535-15.632c0-6.86-2.495-12.786-7.381-17.671C54.47,2.391,48.545,0,41.685,0S28.898,2.391,24.013,7.276
					c-4.886,4.885-7.276,10.811-7.276,17.671s2.391,12.786,7.276,17.671c3.908,3.908,8.483,6.215,13.667,6.984
					c0.36-0.629,0.799-1.218,1.324-1.743L47.859,39.005z"/>
				<path fill="#606060" d="M36.588,89.128c0-2.25,0.854-4.348,2.417-5.918l11.792-11.79L38.999,59.622
					c-1.555-1.559-2.411-3.658-2.411-5.912c0-0.026,0.003-0.052,0.004-0.078c-5.754-0.967-10.834-3.608-15.281-7.894
					c-3.327,0-6.237,0.832-8.732,2.287c-2.599,1.559-4.573,3.43-6.133,5.822c-1.56,2.39-2.807,5.197-3.847,8.522
					c-1.039,3.327-1.662,6.55-2.078,9.876C0.208,75.571,0,79.105,0,82.744c0,4.678,1.352,8.836,4.055,12.162
					C6.757,98.337,9.979,100,13.825,100h30.2l-5.032-5.031C37.442,93.41,36.588,91.336,36.588,89.128z"/>
				<path fill="#606060" d="M72.811,49.405c-0.642-0.497-1.31-0.965-2.021-1.38c-1.171-0.732-2.438-1.274-3.793-1.651l4.422,4.422
					L72.811,49.405z"/>
				<path fill="#606060" d="M63.461,100h6.082c2.657,0,5.1-0.856,7.264-2.571l-5.388-5.387L63.461,100z"/>
			</g>
			<path fill="#CC0000" d="M83.203,71.42l16.211-16.212C99.805,54.817,100,54.296,100,53.71c0-0.52-0.195-1.041-0.586-1.431
				l-8.854-8.854c-0.39-0.392-0.911-0.586-1.432-0.586c-0.587,0-1.107,0.195-1.498,0.586l-16.211,16.21l-16.211-16.21
				c-0.391-0.392-0.911-0.586-1.497-0.586c-0.521,0-1.041,0.195-1.433,0.586l-8.854,8.854c-0.39,0.39-0.586,0.911-0.586,1.431
				c0,0.109,0.014,0.213,0.027,0.317c0.06,0.455,0.241,0.862,0.559,1.181L59.635,71.42L43.424,87.63
				c-0.39,0.392-0.586,0.911-0.586,1.498c0,0.521,0.196,1.041,0.586,1.433l8.854,8.854C52.67,99.806,53.189,100,53.711,100
				c0.586,0,1.106-0.194,1.497-0.586l16.211-16.211L87.63,99.414c0.391,0.392,0.911,0.586,1.498,0.586c0.521,0,1.042-0.194,1.432-0.586
				l8.854-8.854c0.391-0.392,0.586-0.912,0.586-1.433c0-0.587-0.195-1.106-0.586-1.498L83.203,71.42z"/>
		</svg>
	);
};

export default NotShared;
